/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
// import { setCurrentUser } from "../store/actions/authActions.js";
import { Checkbox, Button, Modal } from "flowbite-react";
import { NavLink } from "react-router-dom";
import TableSearchBar from "../../components/TableSearchBar";
import instance, {
  fetchAllDepartments,
  fetchAssessmentDueDate,
} from "../../api/api";
import { initFlowbite } from "flowbite";
import { Loader } from "../../components/Loader";
import PerspectiveBadge from "../../components/PerspectiveBadge";
import { FormateDate } from "../../utils/FormatDate";
import GetScoreColor from "../../utils/GetScoreColor";
// import config from "../../configs/config.json";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
  SortingState,
} from "@tanstack/react-table";
import { sources } from "../../constants/sources";
import { useTenant } from "../../context/Tenant/TenantContext";
import { usePostHog } from "@posthog/react";

type Risk = {
  id?: string;
  riskNumber?: string;
  perspective: string;
  objective: string;
  riskName: string;
  source: string;
  description: string;
  rootCause: string;
  status?: string;
  checked?: boolean;
  objectiveSuggestions?: [];
  rootCauseSuggestions?: [];
  descriptionSuggestions?: [];
  descriptionScore?: number;
  objectiveScore?: number;
  rootCauseScore?: number;
  createdAt?: string;
};
function AdminRiskFinalSelection() {
  const { config, loading: tenantLoading } = useTenant();
  const posthog = usePostHog();
  // const [openModal, setOpenModal] = useState(false);
  const [moveRisksModal, setMoveRisksModal] = useState(false);
  const [allRisks, setAllRisks] = useState<Risk[]>([]);
  const [currentRiskDetails, setCurrentRiskDetails] = useState<any>({});
  const [isLoadingRisks, setIsLoadingRisks] = useState(false);
  const [approvedRisks, setApprovedRisks] = useState<any[]>([]);
  const [isApprovingRisks, setIsApprovingRisks] = useState(false);

  // const [riskScores, setRiskScores] = useState<[string, string][]>([]);

  const [dueDate, setDueDate] = useState<any>(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);

  const [updatedRisk, setUpdatedRisk] = useState<Risk>({
    riskName: "",
    description: "",
    source: "",
    rootCause: "",
    objective: "",
    perspective: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedRiskId, setSelectedRiskId] = useState<string>("");
  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
  const [highlightedRiskId, setHighlightedRiskId] = useState<any>(null);
  // const [sourceSuggestions, setSourceSuggestions] = useState<any[]>([]);
  const [rootCauseSuggestions, setRootCauseSuggestions] = useState<any[]>([]);
  const [descriptionSuggestions, setDescriptionSuggestions] = useState<any[]>(
    []
  );
  const [filteredObjectives, setFilteredObjectives] = useState<string[]>([]);

  const formatDate = (date: any) => {
    const d = new Date(date);
    d.setDate(d.getDate() - 1); // Subtract one day
    const month = `${d.getMonth() + 1}`.padStart(2, "0");
    const day = `${d.getDate()}`.padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  // useEffect(() => {
  //   setRiskScores(Object.entries(config.Acceptance));
  // }, []);

  const [departments, setDepartments] = useState<any[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [sorting, setSorting] = useState<SortingState>([
    { id: "perspective", desc: false },
  ]);

  useEffect(() => {
    const fetchDueDate = async () => {
      const theDueDate = await fetchAssessmentDueDate();
      setDueDate(formatDate(theDueDate ? theDueDate : new Date()));
    };

    fetchDueDate();
    const fetchDepartments = async () => {
      setDepartments(await fetchAllDepartments());
    };
    fetchDepartments();
  }, []);

  useEffect(() => {
    posthog?.capture("page_viewed", { page: "admin_risk_final_selection" });
  }, [posthog]);

  const getAllRisks = async () => {
    try {
      let response;
      setIsLoadingRisks(true);
      if (selectedDepartment === "" || selectedDepartment === "All") {
        response = await instance.get(
          "/api/admin/riskRegister/riskRegisters/selections/ASSESSMENT_IN_PROGRESS"
        );
        setIsLoadingRisks(false);
      } else {
        response = await instance.get(
          `/api/admin/riskRegister/riskRegisters/department?departmentName=${selectedDepartment}`
        );
        setIsLoadingRisks(false);
      }
      initFlowbite();
      const risksWithChecked = response.data.data.map((risk: any) => ({
        ...risk,
        checked: risk.status === "SELECTION_COMPLETE" ? true : false,
      }));

      if (risksWithChecked.length > 0) {
        const risksWithAverages = risksWithChecked.map((risk: any) => {
          const average = response.data.roundedAverages.find(
            (avg: any) => avg.riskRegisterId === risk.id
          );
          const objectiveSuggestionsArray: { suggestion: any; score: any }[] =
            [];
          const rootCauseSuggestionsArray: { suggestion: any; score: any }[] =
            [];
          const descriptionSuggestionsArray: {
            suggestion: any;
            score: any;
          }[] = [];
          const sourceSuggestionsArray: { suggestion: any; score: any }[] = [];
          if (risk.RiskRegisterUserScore) {
            risk.RiskRegisterUserScore.forEach((userScore: any) => {
              if (userScore.objectiveSuggestion) {
                objectiveSuggestionsArray.push({
                  suggestion: userScore.objectiveSuggestion,
                  score: userScore.objectiveScore,
                });
              }
              if (userScore.descriptionSuggestion) {
                descriptionSuggestionsArray.push({
                  suggestion: userScore.descriptionSuggestion,
                  score: userScore.descriptionScore,
                });
              }
              if (userScore.rootCauseSuggestion) {
                rootCauseSuggestionsArray.push({
                  suggestion: userScore.rootCauseSuggestion,
                  score: userScore.rootCauseScore,
                });
              }
            });
          }

          return {
            ...risk,
            objectiveSuggestions: objectiveSuggestionsArray,
            rootCauseSuggestions: rootCauseSuggestionsArray,
            descriptionSuggestions: descriptionSuggestionsArray,
            sourceSuggestions: sourceSuggestionsArray,
            descriptionScore: average ? average._avg.descriptionScore : 0,
            objectiveScore: average ? average._avg.objectiveScore : 0,
            // sourceScore: average ? average._avg.sourceScore : 0,
            rootCauseScore: average ? average._avg.rootCauseScore : 0,
          };
        });

        console.log(risksWithAverages);

        setDescriptionSuggestions(
          risksWithAverages.reduce(
            (acc: any, risk: any) => [...acc, ...risk.descriptionSuggestions],
            []
          )
        );
        setRootCauseSuggestions(
          risksWithAverages.reduce(
            (acc: any, risk: any) => [...acc, ...risk.rootCauseSuggestions],
            []
          )
        );
        setAllRisks(risksWithAverages);
      } else {
        setAllRisks([]);
      }
    } catch (error) {
      setIsLoadingRisks(false);
      console.error(error);
    }
  };
  useEffect(() => {
    getAllRisks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDepartment]);

  const handleCheckboxClick = (id: any) => {
    // Find the clicked row and update its checked status
    const updatedData = allRisks.map((row) =>
      row.id === id ? { ...row, checked: !row.checked } : row
    );

    // Move the checked row to the top and update state
    const newlyApproved = updatedData.filter((row) => row.checked);
    
    // const selectedRisks = checkedRows.map((row) => row.id);
    setApprovedRisks(newlyApproved);

    setAllRisks(updatedData);
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the items to display based on the current page and items per page
  const paginatedRisks = React.useMemo(() => {
    let risksToDisplay = allRisks;

    // Only show risks that have both description and root cause scores
    risksToDisplay = risksToDisplay.filter(
      (risk: any) =>
        risk.descriptionScore != null &&
        risk.descriptionScore > 0 &&
        risk.rootCauseScore != null &&
        risk.rootCauseScore > 0
    );

    // Apply search filter
    if (searchTerm) {
      risksToDisplay = risksToDisplay.filter((risk: any) =>
        Object.values(risk).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return risksToDisplay.slice(indexOfFirstItem, indexOfLastItem);
  }, [allRisks, currentPage, itemsPerPage, searchTerm]);

  const totalPages = Math.ceil(
    allRisks.filter(
      (risk: any) =>
        risk.descriptionScore != null &&
        risk.descriptionScore > 0 &&
        risk.rootCauseScore != null &&
        risk.rootCauseScore > 0
    ).length / itemsPerPage
  );

  const editDrawerRef = useRef<any>(null);
  const closeEditRiskDrawerButtonRef = useRef<any>(null);

  const getObjectivesForPerspective = (p: string) => {
    if (!p) return [];
    return config.Factors.filter(
      (factor: any) => Object.keys(factor)[0] === p
    ).flatMap((factor: any) => Object.values(factor)[0] as string[]);
  };

  const handleEditClick = (
    riskId: string,
    riskName: string,
    description: string,
    source: string,
    rootCause: string,
    perspective: string,
    objective: string
  ) => {
    setSelectedRiskId(riskId);
    setIsEditDrawerOpen(true);
    setHighlightedRiskId(riskId);
    const objectives = getObjectivesForPerspective(perspective);
    setFilteredObjectives(objectives);
    setCurrentRiskDetails({
      riskName: riskName,
      description: description,
      source: source,
      rootCause: rootCause,
      perspective,
      objective,
    });
    setUpdatedRisk({
      riskName: riskName,
      description: description,
      source: source,
      rootCause: rootCause,
      perspective: perspective,
      objective: objectives.includes(objective) ? objective : "",
    });
  };

  const updateRisk = async (e: any) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await instance.put(
        `/api/employee/riskRegister/update/${selectedRiskId}`,
        updatedRisk
      );
      if (closeEditRiskDrawerButtonRef.current) {
        closeEditRiskDrawerButtonRef.current.click();
      }
      setIsSubmitting(false);
      await getAllRisks();
    } catch (error) {
      setIsSubmitting(false);
      return error;
    }
  };

  const handleMoveRisksToNextStage = async () => {
    setIsApprovingRisks(true);
    try {
      for (const risk of approvedRisks) {
        // await instance.put(`/api/admin/riskAssessment/update/status/${risk}`, {
        //   status: "APPROVED_FOR_ACTION",
        // });

        if (
          risk.status === "ASSESSMENT_IN_PROGRESS" &&
          risk.descriptionScore !== 0 &&
          risk.rootCauseScore !== 0
        ) {
          await instance.put(
            `/api/admin/riskRegister/update/status/${risk.id}`,
            {
              status: "SELECTION_COMPLETE",
            }
          );
        }

        if (risk.descriptionScore !== 0 && risk.rootCauseScore !== 0) {
          await instance.post(
            `/api/employee/riskAssessment/create/${risk.id}`,
            {
              likeLihoodValue: "",
              likeLihoodComment: "",
              riskConsequenceValue: "",
              riskConsequenceComment: "",
              controlEffectiveness: "",
              status: "APPROVED_FOR_ACTION",
            }
          );
        }
      }
      if (dueDate) {
        await instance.post(
          `/api/admin/riskDuedate/riskDuedates/create/APPROVED_FOR_ACTION`,
          {
            riskStatus: "APPROVED_FOR_ACTION",
            dueDate: dueDate,
          }
        );
      } else {
        await instance.post(
          `/api/admin/riskDuedate/riskDuedates/create/APPROVED_FOR_ACTION`,
          {
            riskStatus: "APPROVED_FOR_ACTION",
          }
        );
      }
      await instance.post("/api/admin/emails/stage-kickoff ", {
        stageName: "Risk Assessment",
        role: "EMPLOYEE",
        riskStatus: "APPROVED_FOR_ACTION",
      });
      posthog?.capture("risk_final_selection_finalized", { risksCount: approvedRisks.length });
      setIsApprovingRisks(false);
      window.location.reload();
    } catch (error) {
      setIsApprovingRisks(false);
      console.error(error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        editDrawerRef.current &&
        !editDrawerRef.current.contains(event.target)
      ) {
        setIsEditDrawerOpen(false);
        setHighlightedRiskId(null);
      }
    };

    if (isEditDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      setHighlightedRiskId(null);
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditDrawerOpen]);

  const columnHelper = createColumnHelper<Risk>();
  const columns = [
    columnHelper.accessor("riskNumber", {
      header: "Risk Number",
      cell: (info) => (
        <span className="whitespace-nowrap font-bold">
          {(info.row.original.descriptionScore ?? 0) > 0 &&
          (info.row.original.rootCauseScore ?? 0) > 0 ? (
            <span className="mr-2">
              <Checkbox
                className="text-caribbeanCurrent"
                checked={info.row.original.checked}
                onChange={() => handleCheckboxClick(info.row.original.id)}
              />
            </span>
          ) : null}
          {info.getValue()}
        </span>
      ),
    }),
    columnHelper.accessor("createdAt", {
      header: () => <span className="whitespace-nowrap">Created Date</span>,
      cell: (info) => (
        <span className="whitespace-nowrap">
          {info.getValue() ? FormateDate(info.getValue()) : ""}
        </span>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("perspective", {
      header: "Perspective",
      cell: (info) => <PerspectiveBadge value={info.getValue()} />,
    }),
    columnHelper.accessor("objective", {
      header: "Objective",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("riskName", {
      header: () => <span>Risk Name</span>,
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("source", {
      header: "Source",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("description", {
      header: "Description",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("rootCause", {
      header: () => "Root Cause",
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.display({
      id: "actions",
      header: () => <span>Actions</span>,
      cell: ({ row }) => (
        <button
          type="button"
          className="w-auto flex justify-center items-center text-caribbeanCurrent hover:text-white border border-caribbeanCurrent hover:bg-caribbeanCurrent focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-4 py-2 text-center inline-flex me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-blue-800"
          data-drawer-target="drawer-edit-risk"
          data-drawer-show="drawer-edit-risk"
          data-drawer-placement="right"
          aria-controls="drawer-edit-risk"
          onClick={() =>
            handleEditClick(
              row.original.id || "",
              row.original.riskName,
              row.original.description,
              row.original.source,
              row.original.rootCause,
              row.original.perspective,
              row.original.objective
            )
          }
        >
          <svg
            className="w-4 h-4 text-white-800 dark:text-white me-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Edit
        </button>
      ),
    }),
  ];

  const table = useReactTable<Risk>({
    data: paginatedRisks,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting,
    },
    onSortingChange: setSorting,
  });

  if (tenantLoading || !config) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader size="xl" />
      </div>
    );
  }

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className=" text-sm font-medium text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Registration
              </NavLink>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center ">
              <svg
                className="rtl:rotate-180 w-3 h-3 mx-1 text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="mx-1 text-sm font-medium text-gray-500 md:mx-2 dark:text-gray-400">
                Final Selection
              </span>
            </div>
          </li>
        </ol>
      </nav>
      <h1 className="text-xl mb-3 font-semibold text-gray-700">
        Final Selection
      </h1>

      <form className="flex max-w-sm my-4 justify-center items-center">
        <label
          htmlFor="countries"
          className="block mb-2 text-md font-medium text-gray-900 dark:text-white"
        >
          Department
        </label>
        <select
          id="countries"
          className="ml-5 bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          onChange={(e) => setSelectedDepartment(e.target.value)}
        >
          <option>All</option>
          {departments &&
            departments.map((department, index) => (
              <option key={index}>{department.name}</option>
            ))}
        </select>
      </form>

      <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4">
        <div className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white dark:text-white dark:bg-gray-800 sticky top-0 z-20">
          <div className="w-full flex items-center justify-between">
            <p>Department Risks</p>
            <div className="flex flex-row gap-4 items-center justify-center">
              <div className="">
                <TableSearchBar
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  placeholder="Search risks..."
                />
              </div>
            </div>
          </div>
        </div>
        <div className="rt-wrap relative sm:rounded-lg max-h-[calc(100vh-300px)] overflow-y-auto">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-sm text-jet font-bold bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0 z-10">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    const isSorted = header.column.getIsSorted();
                    const isActionsColumn = header.column.id === "actions";
                    return (
                      <th
                        scope="col"
                        key={header.id}
                        className={`px-6 py-3 ${
                          isActionsColumn
                            ? "sticky right-0 bg-gray-50 dark:bg-gray-700 z-10"
                            : ""
                        }`}
                        aria-sort={
                          isSorted === "asc"
                            ? "ascending"
                            : isSorted === "desc"
                            ? "descending"
                            : "none"
                        }
                      >
                        {header.isPlaceholder ? null : (
                          <button
                            type="button"
                            className={`flex items-center gap-1 select-none ${
                              header.column.getCanSort()
                                ? "cursor-pointer"
                                : "cursor-default"
                            }`}
                            onClick={header.column.getToggleSortingHandler()}
                            title={
                              header.column.getCanSort() ? "Sort" : undefined
                            }
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                            {header.column.getCanSort() && (
                              <span className="text-xs">
                                {isSorted === "asc"
                                  ? "▲"
                                  : isSorted === "desc"
                                  ? "▼"
                                  : "⇅"}
                              </span>
                            )}
                          </button>
                        )}
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            {isLoadingRisks ? (
              <tbody>
                <tr className="text-center">
                  <td colSpan={7} className="text-center">
                    <div className="flex justify-center items-center h-96">
                      <Loader size={"xl"} />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="text-jet font-medium text-xs">
                {table.getRowModel().rows.map((row) => (
                  <>
                    <tr
                      key={row.id}
                      className={`bg-gray hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 ${
                        highlightedRiskId === row.original.id
                          ? "bg-gray-200"
                          : ""
                      }`}
                    >
                      {row.getVisibleCells().map((cell) => {
                        const isActionsColumn = cell.column.id === "actions";
                        return (
                          <td
                            className={`px-6 py-4 align-top ${
                              isActionsColumn
                                ? "sticky right-0 bg-white dark:bg-gray-800"
                                : ""
                            }`}
                            key={cell.id}
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </td>
                        );
                      })}
                    </tr>
                    <tr className="bg-transparent">
                      {row.getVisibleCells().map((cell) => {
                        const isActionsColumn = cell.column.id === "actions";
                        return (
                          <td
                            className={`px-6 py-2 border-b text-gray-500 text-xs bg-transparent ${
                              isActionsColumn
                                ? "sticky right-0 bg-white dark:bg-gray-800"
                                : ""
                            }`}
                            key={`${cell.id}-score`}
                          >
                            {cell.column.id === "description" && (
                              <div className="font-bold text-gray-500">
                                Comment:{" "}
                                <span
                                  className={GetScoreColor(
                                    row.original.descriptionScore
                                  )}
                                >
                                  {row.original.descriptionScore}
                                </span>
                              </div>
                            )}
                            {cell.column.id === "rootCause" && (
                              <div className="font-bold text-gray-500">
                                Comment:{" "}
                                <span
                                  className={GetScoreColor(
                                    row.original.rootCauseScore
                                  )}
                                >
                                  {row.original.rootCauseScore}
                                </span>
                              </div>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  </>
                ))}
              </tbody>
            )}
          </table>
          {/* Pagination */}
          <div className="mt-4 pl-10 pr-10 pb-5">
            <nav aria-label="Page navigation">
              <ul className="flex justify-between">
                <li className="flex flex-row items-center">
                  <div>
                    <p>Show rows per page</p>
                  </div>
                  <div>
                    <select
                      className="ml-2 bg-gray-50 border border-caribbeanCurrent text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>
                </li>
                <li className="flex flex-row gap-1 items-center text-gray-500">
                  <div>
                    <p>
                      {currentPage} of {totalPages === 0 ? 1 : totalPages}
                    </p>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      {"<"}
                    </button>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      {">"}
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* drawers */}
      {/* edit risk */}
      {allRisks.length > 0 && (
        <div
          id="drawer-edit-risk"
          ref={editDrawerRef}
          className={`fixed top-0 right-0 z-50 h-screen p-4 overflow-y-auto transition-transform ${
            isEditDrawerOpen ? "translate-x-0" : "translate-x-full"
          } bg-white w-full md:w-1/4 dark:bg-gray-800`}
          tabIndex={-2}
          aria-labelledby="drawer-edit-risk-label"
        >
          <h5
            id="drawer-label"
            className="inline-flex items-center mb-6 text-base font-semibold text-gray-500  dark:text-gray-400"
          >
            Edit Risk
          </h5>
          <p className="text-sm my-4 text-gray-400">
            You are allowed to edit your risk before due date.
          </p>
          <button
            type="button"
            data-drawer-hide="drawer-new-risk"
            aria-controls="drawer-new-risk"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
            ref={closeEditRiskDrawerButtonRef}
            onClick={() => setIsEditDrawerOpen(false)}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          <form key={currentRiskDetails?.id}
            onSubmit={updateRisk}
            className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4 p-4"
          >
            <div className="mb-6">
              <label
                htmlFor="riskGoals"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Perspective
              </label>
              <select
                id="perspective"
                required
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  const selectedPerspective = e.target.value;

                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    perspective: selectedPerspective,
                    // Reset objective when perspective changes
                    objective: "",
                  }));

                  // Use the newly selected perspective here
                  const objectives =
                    getObjectivesForPerspective(selectedPerspective);
                  setFilteredObjectives(objectives);
                }}
                value={updatedRisk.perspective || ""} // keep controlled
              >
                <option>Select Perspective</option>
                {config.Perspective.map((perspective: any, index: any) => (
                  <option key={index} value={perspective}>
                    {perspective}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-6">
              <label
                htmlFor="objective"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Objective
              </label>
              <select
                id="objective"
                required
                className="bg-gray-50 border border-caribbeanCurrent text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    objective: e.target.value,
                  }));
                }}
                value={updatedRisk.objective || ""} // make controlled (replace defaultValue)
                disabled={!updatedRisk.perspective} // optional: disable until perspective chosen
              >
                <option>Select Objective</option>
                {filteredObjectives.map((objective, index) => (
                  <option key={index} value={objective}>
                    {objective}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskName"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Name
              </label>
              <input
                type="text"
                id="riskName"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Risk title goes here"
                required
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    riskName: e.target.value,
                  }));
                }}
                defaultValue={currentRiskDetails.riskName}
              />
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskSource"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Source
              </label>
              <select
                id="riskSource"
                className=" bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    source: e.target.value,
                  }));
                }}
                value={updatedRisk.source || ""}
              >
                <option>Select Source</option>
                {sources.map((source, index) => (
                  <option key={index}>{source}</option>
                ))}
              </select>
              {/* <div className="pt-2">
                <h4 className="text-sm">Source Suggestions</h4>
                <div className="text-xs">
                  {sourceSuggestions &&
                    sourceSuggestions.map((suggestion, index) => (
                      <p>
                        Score:{" "}
                        <span className={GetScoreColor(suggestion.score)}>
                          {suggestion.score}
                        </span>{" "}
                        - {suggestion.suggestion}
                      </p>
                    ))}
                </div>
              </div> */}
            </div>
            <div className="mb-6">
              <label
                htmlFor="riskDescription"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Risk Description
              </label>
              <textarea
                id="riskDescription"
                rows={4}
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    description: e.target.value,
                  }));
                }}
                defaultValue={currentRiskDetails.description}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Description goes here..."
              ></textarea>
              <div className="pt-2">
                <h4 className="text-sm">Description Suggestions</h4>
                <div className="text-xs">
                  {descriptionSuggestions &&
                    descriptionSuggestions.map((suggestion, index) => (
                      <p>
                        Score:{" "}
                        <span className={GetScoreColor(suggestion.score)}>
                          {suggestion.score}
                        </span>{" "}
                        - {suggestion.suggestion}
                      </p>
                    ))}
                </div>
              </div>
            </div>
            <div className="mb-6">
              <label
                htmlFor="rootCause"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Root Causes
              </label>
              <textarea
                id="rootCause"
                rows={4}
                onChange={(e) => {
                  setUpdatedRisk((prevState) => ({
                    ...prevState,
                    rootCause: e.target.value,
                  }));
                }}
                defaultValue={currentRiskDetails.rootCause}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Root cause goes here..."
              ></textarea>
              <div className="pt-2">
                <h4 className="text-sm">Root Cause Suggestions</h4>
                <div className="text-xs">
                  {rootCauseSuggestions &&
                    rootCauseSuggestions.map((suggestion, index) => (
                      <p>
                        Score:{" "}
                        <span className={GetScoreColor(suggestion.score)}>
                          {suggestion.score}
                        </span>{" "}
                        - {suggestion.suggestion}
                      </p>
                    ))}
                </div>
              </div>
            </div>
            <div className="flex gap-4">
              <button
                disabled={isSubmitting}
                type="submit"
                className={`text-white bg-caribbeanCurrent hover:bg-blue-800 w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block ${
                  isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                {isSubmitting ? <Loader size="sm" /> : "Save Risk"}
              </button>

              <button
                className="text-black bg-white border-2 border-caribbeanCurrent hover:bg-caribbeanCurrent hover:text-white w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block"
                onClick={(e) => {
                  e.preventDefault();
                  setIsEditDrawerOpen(false);
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="border-red-300 dark:border-gray-600 h-54 mb-4">
        <div className="space-y-6">
          {/* <h3 className="text-riskRed font-medium text-lg">
            {" "}
            Move To Assessment Stage
          </h3> */}
          <Button
            onClick={() => setMoveRisksModal(true)}
            disabled={approvedRisks.length === 0}
            className="bg-riskRed font-bold"
          >
            Move Risks
          </Button>
          <Modal
            dismissible
            show={moveRisksModal}
            size="xl"
            onClose={() => setMoveRisksModal(false)}
            popup
          >
            {/* <Modal dismissible show={openModal} onClose={() => setOpenModal(false)}> */}
            <Modal.Header className="ml-3 p-5 border-b">
              <h4 className="font-bold text-gray-700 dark:text-gray-400">
                Move Risks To Assessment Stage
              </h4>
            </Modal.Header>
            <Modal.Body>
              <div className="space-y-5 p-3">
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  Are you sure you want to promote these risks to the assessment
                  stage?
                </p>
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  <span className="font-bold">Note: </span> You can't undo this
                  action
                </p>
              </div>
              {!dueDate && (
                <span className="space-y-5 p-3 text-red">
                  Please set a due date!
                </span>
              )}
            </Modal.Body>
            <Modal.Footer className="border-t">
              <Button
                color="gray"
                className="border-none text-riskRed"
                onClick={() => setMoveRisksModal(false)}
              >
                Cancel
              </Button>
              <Button
                className="bg-riskRed hover:bg-riskRed"
                disabled={!dueDate}
                onClick={() => {
                  handleMoveRisksToNextStage();
                }}
              >
                {isApprovingRisks ? <Loader size="sm" /> : "Confirm"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default connect()(AdminRiskFinalSelection);
